/**
 * Renewal price (DECISIONS.md A-R5): USD, exactly two decimal places, exact representation.
 * Amounts travel as decimal strings and are stored as numeric(12,2); they are never converted
 * to JavaScript numbers.
 */
export const RENEWAL_CURRENCY = 'USD';

/** Up to 10 integer digits (numeric(12,2)) and exactly two decimals, e.g. "1500.00". */
export const MONEY_PATTERN = /^\d{1,10}\.\d{2}$/;

export function isMoneyAmount(value: string): boolean {
  return MONEY_PATTERN.test(value);
}
